import { QRCodeCanvas } from 'qrcode.react';
import React, { ComponentPropsWithRef, FC } from 'react';
import { DeviceType } from '@components/LandingPageApp/types';
import { PlcImg } from '@components/PlcImg/PlcImg.component';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { Constants } from '@utils/Constants';
import classnames from 'classnames';
import styles from './DownloadAppButtons.module.scss';

type Props = ComponentPropsWithRef<'div'> & {
  handleTagClick: (clickName: string, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const DownloadAppButtons: FC<Props> = ({ className, handleTagClick }) => {
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  const rootClass = classnames(className, styles['plc-stores']);
  // const [device, setDevice] = useState<'iOS' | 'Android' | 'other'>('other');

  // useEffect(() => {
  //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  //   setDevice(getDeviceType(userAgent));
  // }, []);

  // const appStore = (
  //   <PlcImg
  //     alt="Télécharger dans l’App Store"
  //     className={styles.store}
  //     plcSrc={{
  //       src: 'app-store',
  //       type: 'local',
  //     }}
  //   />
  // );
  const googleStore = (
    <PlcImg
      alt="Disponible sur Google Play"
      className={styles.store}
      plcSrc={{
        src: 'google-play',
        type: 'local',
      }}
    />
  );

  return (
    <div className={rootClass}>
      <Text alignment="center" className="plc-my-s" i18nKey="landing-app.download" variant="h4" />
      {!isMobile && (
        <div className="flexCenter column">
          <QRCodeCanvas
            className="plc-p-s"
            size={200}
            value={Constants.STORE.GOOGLE}
            // value={device === 'iOS' ? Constants.STORE.APPLE : Constants.STORE.GOOGLE}
          />
        </div>
      )}
      <div className={styles.buttons}>
        <a href={Constants.STORE.GOOGLE} onClick={(event) => handleTagClick(DeviceType.Android, event)} target="_blank">
          {googleStore}
        </a>

        {/* <a href={Constants.STORE.APPLE} onClick={(event) => handleTagClick(DeviceType.iOS, event)} target="_blank"> */}
        {/*  {appStore} */}
        {/* </a> */}
      </div>
      <Text alignment="center" className="plc-mb-s" i18nKey="Bientôt disponible sur App Store" variant="h6" />
    </div>
  );
};

export { DownloadAppButtons };
